<benefits-form-stepper-card
  [headerText]="step?.title || 'Form'"
  [disableBack]="(componentRef?.instance?.disableBack$ | async) === true"
  [disableNext]="disableNext || (componentRef?.instance?.isLoading$ | async) === true"
  [onlyShowNext]="(componentRef?.instance?.onlyShowNext)"
  [loading]="(componentRef?.instance?.isLoading$ | async) === true"
  (backClick)="backClick()"
  (nextClick)="nextClick()"
  [nextButtonText]="componentRef?.instance?.nextButtonText ?? 'Next'"
  [backButtonText]="componentRef?.instance?.backButtonText ?? 'Back'"
>
  <ng-template dynamicComponentHost></ng-template>
</benefits-form-stepper-card>
